/* eslint-disable import/prefer-default-export */
const init = () => {
  const nav = document.querySelector('.account-section-nav');
  if (!nav) {
    return;
  }

  nav.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link || !nav.contains(link)) {
      return;
    }

    const id = (link.getAttribute('href') || '').slice(1);
    if (!id) {
      return;
    }

    const target = document.getElementById(id);
    if (!target) {
      return;
    }

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
};

export {
  init,
};
/* eslint-enable import/prefer-default-export */
